import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';

const StripeCancel = () => {
  const { user } = useAuth();
  const [countdown, setCountdown] = useState(8);

  const isCoach = user?.role === 'coach';
  const redirectTo = isCoach ? '/coach/finances' : '/user/billing';

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          window.location.href = redirectTo;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [redirectTo]);

  return (
    <div className="min-h-screen bg-[var(--bg-main)] flex items-center justify-center px-4 font-display">
      <div className="bg-[var(--surface-white)] rounded-3xl border border-[var(--border-light)] shadow-2xl shadow-black/10 p-10 max-w-md w-full text-center">

        {/* Icon */}
        <div className="relative mx-auto mb-8 w-24 h-24">
          <div className="w-24 h-24 bg-orange-500/10 border border-orange-500/20 rounded-full flex items-center justify-center shadow-sm">
            <svg className="w-12 h-12 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
        </div>

        <h1 className="text-2xl font-bold text-[var(--text-primary)] mb-2">
          Payment Cancelled
        </h1>
        <p className="text-[var(--text-secondary)] text-sm mb-8 leading-relaxed">
          No worries — your payment was not processed and you haven't been charged.
          You can try again whenever you're ready.
        </p>

        <div className="space-y-3 mb-8">
          <Link
            to={redirectTo}
            className="flex items-center justify-center gap-2 w-full px-6 py-3 bg-tangerine text-white font-bold rounded-2xl shadow-md shadow-tangerine/20 hover:-translate-y-0.5 transition-all text-sm"
          >
            <span className="material-symbols-outlined text-lg">credit_card</span>
            Try Again
          </Link>
          <Link
            to={isCoach ? '/coach/dashboard' : '/user/chat'}
            className="flex items-center justify-center gap-2 w-full px-6 py-3 bg-[var(--off-white)] border border-[var(--border-light)] text-[var(--text-secondary)] font-bold rounded-2xl hover:border-[var(--tangerine)] hover:text-tangerine transition-all text-sm"
          >
            <span className="material-symbols-outlined text-lg">home</span>
            Back to Dashboard
          </Link>
        </div>

        <div className="flex items-center justify-center gap-2 text-xs text-[var(--text-secondary)]/60">
          <div className="w-4 h-4 border-2 border-[var(--border-light)] border-t-gray-400 rounded-full animate-spin" />
          Redirecting in {countdown}s...
        </div>
      </div>
    </div>
  );
};

export default StripeCancel;
